import React from 'react';
import {toJS} from 'mobx';
import {observer} from 'mobx-react';

import ListTable from '@components/ListTable/ListTable.jsx';

import user_bet_record_store, {filter_store, pagination_store} from '@store/User/UserList/UserBetRecordStore';
import OrderDetailModal from '@ViewsDashboard/User/UserList/Order/OrderDetailModal';

@observer
class UserListTable extends React.Component {


    constructor() {
        super();
    }

    componentWillMount() {
        this.setState({
            expandedRowKeys: []
        });
    }

    componentWillUnmount() {
        this.setState({
            expandedRowKeys: []
        });
        filter_store.resetAttr();
    }

    expandedRowRender = (record, index, indent, expanded) => {
        //请求当前order数据
        // orderDetailStore.getOrderDetail(record.order_id);

        //防止重复加载没必要的数据
        if (this.state.expandedRowKeys.indexOf(record.order_id) == -1) {
            return (<div></div>);
        }

        return (
            <OrderDetailModal
                orderId={record.order_id}
                expanded={expanded}
            />
        )
    };

    onExpandedRowChange = (expanded_rows) => {
        this.setState({
            expandedRowKeys: [expanded_rows[expanded_rows.length - 1]]
        });
    };

    columns = [
        {
            title: '投注时间',
            dataIndex: 'time'
        },
        {
            title: '订单ID',
            dataIndex: 'order_id',
        },
        {
            title: '玩法类型',
            dataIndex: 'play_type',
        },
        {
            title: '游戏名称',
            dataIndex: 'type',
        },
        {
            title: '投注金额',
            className: 'column-money',
            render(text, record, index) {
                return (
                    <span>
            ￥{window.FormatAmount(record.amount)}
          </span>
                )
            }
        },
        {
            title: '派彩',
            className: 'column-money',
            render(text, record, index) {
                return (
                    <span>
            ￥{window.FormatAmount(record.win_tax_money)}
          </span>
                )
            }
        },
        {
            title: '开奖结果',
            dataIndex: 'result',
        },
        {
            title: '出票结果',
            dataIndex: 'status',
        },
        {
            title: '是否合买',
            dataIndex: 'is_community',
            render(text, record, index) {
                return (
                    <span>
            {record.is_community == false ? '否' : '是'}
          </span>
                )
            }
        }
    ];

    /**
     * 分页器点击回调
     * @param {number} page
     * @param {number} size
     */
    pagination_callback(page, size, order_by) {
        user_bet_record_store.searchByFilter({
            page: page,
            page_size: size,
            order_by: order_by,
        })
    }


    render() {
        return (
            <ListTable
                data_source={toJS(user_bet_record_store.item_array)}
                columns={this.columns}

                pagination={
                    {
                        // 当前页
                        current: pagination_store.page_cur,
                        // 每页条数
                        pageSize: pagination_store.page_size,
                        // 总数据条数
                        total: pagination_store.data_total,
                        // 页码候选列表
                        pageSizeOptions: pagination_store.page_size_options,
                    }
                }
                expandedRowKeys={
                    this.state.expandedRowKeys
                }
                expandedRowRender={
                    this.expandedRowRender
                }
                onChange={
                    (pagination, filters, sorter) => {
                        let current = pagination.current;
                        let page_size = pagination.pageSize;
                        let order_by = `${sorter.columnKey}@${sorter.order}`;

                        this.pagination_callback(current, page_size, order_by);
                    }
                }
                onExpand={(expanded, record) => {
                    //这里请求会导致界面显示异常
                    //请求当前order数据
                    // orderDetailStore.getOrderDetail(record.order_id);
                }
                }
                onExpandedRowsChange={(expandedRows) => {
                    // alert(expandedRows);
                    this.onExpandedRowChange(expandedRows)
                }}
                expandRowByClick
            />
        )
    }
}

export default UserListTable;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserBetRecord/UserBetRecordListTable.jsx